// Version : 0.0.3
// Author : VIGNESH
// LastEdit : VISHAL BHARATHI
// Last ADD : ENACH REPORT EXPORT TYPES REMOVED
// MODIFIED DATE: 19-09-2025

const ENACHReportActionTypes = {
	/** *********************  START OF GET ENACH REPORT  ******************** */
	FETCH_ENACH_REPORT_START: 'fetch_enach_report_Start',
	FETCH_ENACH_REPORT_SUCCESS: 'fetch_enach_report_Success',
	FETCH_ENACH_REPORT_FAILURE: 'fetch_enach_report_Failure',
	FETCH_ENACH_REPORT_RESPONSE_RESET: 'fetch_enach_report_ResponseReset',
	FETCH_ENACH_REPORT_RESPONSE_CHANGED: 'fetch_enach_report_ResponseChanged',
	/** *********************  END OF GET ENACH REPORT  ******************** */
};
export default ENACHReportActionTypes;
